import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-web-push-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/web-push-template/"
      channelLabel="Web Push"
      namePlaceholder="Enter web push name"
      emptyMessage="No web push found!"
      heartbeatType="web-push"
      [showResponsysButton]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class WebPushTemplateComponent {
  protected readonly templateType = TypeEnum.WEBPUSH;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    {
      name: 'web-push',
      variables: {
        WebPushCopy: '',
        WebPushCta: '',
        WebPushImage: '',
        WebPushLink: '',
        WebPushTitle: '',
      },
    },
  ];
}
